module.exports = __webpack_public_path__ + "static/media/underConstruction.f4b621dc.png";